import React from "react";
import { Breadcrumb, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Routes } from "../../../routes";

import FormPermissions from './FormPermissions'
import FormLoader from './FormLoader'
import PointsBalanceWidget from '../../member-points/review/Widget'
import WidgetMemberTransactions from '../../transactions/WidgetMemberTransactions'

const Component = () => {
    return (
        <>
            <div className="d-lg-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="mb-4 mb-lg-0">
                    <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item href={Routes.Dashboard.path}><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item href={Routes.Members.path}>Members</Breadcrumb.Item>
                        <Breadcrumb.Item active>Member</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Member Profile</h4>
                </div>
            </div>
            <Row>
                <Col xs={12} xl={4}>
                    <Row>
                        <Col xs={12}>
                            <FormPermissions>
                                <FormLoader />
                            </FormPermissions>
                        </Col>
                        <Col xs={12}>
                            <PointsBalanceWidget />
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} xl={8}>
                    <WidgetMemberTransactions />
                </Col>
            </Row>
            
        </>
    );
};

export default Component;
